import React, { useState } from "react";
import { Input, Button, message, Typography } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import '../styles/login.css';

const { Title, Paragraph } = Typography;

const ForgotPassword = () => {
  const { t } = useTranslation(); // i18n fonksiyonu
  const [email, setEmail] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const handleSendCode = async () => {
    try {
      await axios.post(`${apiUrl}/api/Suppliers/send-reset-code`, { email });
      message.success(t('verification_code_sent_success'));
      navigate("/verify-reset-code", { state: { email } });
    } catch (error) {
      message.error(t('verification_code_send_error') + ' ' + (error.response?.data || error.message));
    }
  };

  return (
    <div style={pageStyle}>
      <div style={formStyle}>
        <Title level={3}>{t('forgot_password_title')}</Title>
        <Paragraph>{t('forgot_password_description')}</Paragraph>

        <Input
          type="email"
          placeholder={t('email_placeholder')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ marginBottom: 16 }}
        />

        <Button type="primary" block onClick={handleSendCode} disabled={!email}>
          {t('send_verification_code')}
        </Button>
      </div>
    </div>
  );
};

export default ForgotPassword;

// stiller
const pageStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  backgroundColor: "#f5f5f5",
};

const formStyle = {
  width: "100%",
  maxWidth: "400px",
  padding: "32px",
  backgroundColor: "#fff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
};
